import DateUtils = require("VSS/Utils/Date");
import * as LWP from "VSS/LWP";
import { IVssContributionService } from "VSS/Platform/Contribution";

/**
 * Returns collection/account time zone offset from UTC.
 * @returns Offset from UTC in milliseconds.
 */
export function getCollectionTimeZoneOffset(): number {
    const contributionService: IVssContributionService | undefined = LWP.getLWPService("IVssContributionService");
    if (contributionService != null) {
        const result: { utcOffset: number } | undefined = contributionService.getData("ms.vss-dashboards-web.collection-time-zone-data-provider");
        return result ? result.utcOffset : 0;
    } else {
        return 0;
    }
}

/**
 * Gets the local time zone equivalent of today (date as of midnight) in the account time zone.
 * NOTE: So if today is 2016-01-01T00:00:00 in account time zone,
 *       the date returned is 2016-01-01T00:00:00 in the local time zone.
 *       Midnight today might not be 2016-01-01 in the local timezone however.
 * @returns A date object representing today in the account time zone.
 */
export function getTodayInAccountTimeZone(): Date {
    let localNow = new Date();

    // Get time zone offset difference between local and account timezone
    let accountOffsetFromUtcMs = getCollectionTimeZoneOffset();
    let utcOffsetFromLocalMs = localNow.getTimezoneOffset() * DateUtils.MILLISECONDS_IN_MINUTE;
    let localToAccountDifferenceHrs = (accountOffsetFromUtcMs + utcOffsetFromLocalMs) / DateUtils.MILLISECONDS_IN_HOUR;

    // Shift to account and strip time.
    // NOTE: Adjust for any daylight-savings-time changes in the local time since we know the exact difference
    //       we want to add and don't want to apply daylight-savings-time changes/rules of the local time zone.
    let date = DateUtils.addHours(localNow, localToAccountDifferenceHrs, true /* adjustDSTOffset */);
    date = DateUtils.stripTimeFromDate(date);

    return date;
}
